module.exports = __webpack_public_path__ + "img/transactions-accounts-transfer-ok.ba3449c2.svg";